import React from "react";

export const getInfoTitle = (num) => {
  switch (num) {
    case 1:
      return "Wallet inclusion details";
    case 2:
      return "Claim inclusion details";
    case 3:
      return "What is ‘Advanced wallet rules’?";
    case 4:
      return "What is ‘Advanced service level rules’?";
    case 5:
      return "What is ‘Advanced claim rules’?";
    case 6:
      return "What is ‘Additional claim rules’?";
    case 7:
      return "What is ‘Additional plan rules’?";
    default:
      return ""; // optional: return a default value if no case matches
  }
};

const getInfoText = (num) => {
  if (num === 1) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows to configure a digital wallet to the plan. Please
          note that by default a wallet is 'cashless'. 'Claim' has to be enabled
          for a wallet with claim feature.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Wallet Included (Checkbox):&nbsp;&nbsp;
            </span>
            Ticking this checkbox indicates that a digital wallet feature is
            part of the created plan. Only when this box is checked, you will be
            able to view and configure the associated wallet rules and features
            below.
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Wallet type:&nbsp;&nbsp;</span>{" "}
            Choose the type of wallet included in the plan (e.g., Limited,
            Unlimited).
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li>
              Limited wallet:&nbsp;&nbsp; Select this, if you wish to offer a
              predefined capped wallet amount. Wallet can be used to the "Wallet
              limit" amount.
            </li>
          </ul>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li>
              Unlimited wallet:&nbsp;&nbsp; Select this, if you wish to offer a
              uncapped wallet. Uncapped wallet means that their is no limit to
              the wallet amount.
            </li>
          </ul>

          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Wallet limit (Rs.):&nbsp;&nbsp;
            </span>
            This is the maximum amount that can be utilized from the wallet for
            eligible services. This has to be filled if the Wallet type is
            "Limited".
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Family Usage:&nbsp;&nbsp;</span>{" "}
            Specify whether the wallet's limit can be shared and used by the
            family members covered under the same plan. You have the option to
            allow access to all family members or select specific individuals
            from the list.
          </li>
        </ul>
      </div>
    );
  }

  if (num === 2) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          If you want to offer 'file a claim' feature in the app for claims,
          enable this feature to the plan. Kindly note that if you are offering
          only a cashless wallet, this feature should not be enabled.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Claim included (Checkbox):&nbsp;&nbsp;
            </span>
            Ticking this checkbox activates the claim feature, allowing user and
            family members to file claim for eligible services. Only when this
            box is checked, you will be able to configure the family member
            rules below and advanced claim rules.
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Family usage:&nbsp;&nbsp;</span>
            You can select whether the claim benefit can be used by the family
            members covered under the same plan. You have the option to allow
            access to all family members or choose specific individuals from the
            list. Kindly note that in most of the cases, family usage in "Claim"
            section shall be set same as that in the "Wallet" section unless
            clearly specified
          </li>
        </ul>
      </div>
    );
  }

  if (num === 3) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows to define specific financial rules and limits for
          how the digital wallet can be used across different services. These
          rules are configurable based on whether you have selected a Limited or
          Unlimited wallet type for the plan.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Sublimit applicable:&nbsp;&nbsp;
            </span>
            Check this box to set a specific spending limit for a particular
            Service Type (e.g., putting a cap on wallet on Consultation type or
            Health checkup type) within the overall wallet limit.
          </li>

          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the sublimit as either a Percentage (%) or an Amount (Rs.) for the
              Service type.
            </li>
          </ul>

          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Fixed amount:&nbsp;&nbsp;</span>{" "}
            If a particular amount has to be used only for a particular Service
            Type, this should be selected. Example, if Rs. 10,000 sublimit is
            for gym and has to be used for gym only, select Fixed amount for Gym
            memberships.
          </li>
          <li>
            <span style={{ fontWeight: 600 }}>
              Per transaction limit:&nbsp;&nbsp;
            </span>
            Check this box to set a maximum amount that can be used from the
            wallet in a single transaction for that service.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the per transaction limit as either a Percentage (%) or an Amount
              (Rs.) for the Service type.
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: 600 }}>
              Co-Pay by employee:&nbsp;&nbsp;
            </span>
            Check this box if the employee is required to pay a partial amount
            out of pocket for the service availed.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the co-pay amount as either a Percentage (%) or an Amount (Rs.)
              for the Service type.
            </li>
          </ul>
        </ul>
      </div>
    );
  }

  if (num === 4) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows to define specific financial rules at the
          individual Service ID level. These rules are more granular than the
          broader service type rules and are applied as an alternative, not in
          combination with service type rules.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Service ID: &nbsp;&nbsp;</span>
            Define the sublimit as either a Percentage (%) or an Amount (Rs.)
            for the Service.
          </li>

          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Transaction sublimit name: &nbsp;&nbsp;
            </span>
            Define a name that will be shown on card in transaction sub limits
            section in app.
          </li>

          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Sublimit applicable:&nbsp;&nbsp;
            </span>{" "}
            Check this box to set a spending limit for the service ID.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the sublimit as either a Percentage (%) or an Amount (Rs.) of the
              service cost.
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: 600 }}>Fixed amount:&nbsp;&nbsp; </span>
            Check this box, if a particular amount has to be used only for a
            particular Service ID. Example, if Rs. 6,500 can be used only for
            Service ID 65, select Fixed amount.
          </li>
        </ul>
      </div>
    );
  }

  if (num === 5) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows to define specific rules and limits for different
          types of claims. These rules are configurable only if the 'Claim
          included' option is enabled in the plan.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Claim type / Service type:&nbsp;&nbsp;
            </span>
            Fill the claim type for which you want to set claim rules and select
            the specific category of service (e.g., Consultation, Pharmacy) if
            it can be mapped with claim type.
          </li>

          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Sublimit applicable:&nbsp;&nbsp;
            </span>{" "}
            Check this box to set a maximum amount that can be claimed for a
            specific service within the overall claim limit.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the sublimit as either a Percentage (%) or an Amount (Rs.) for the
              Service type.
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: 600 }}>Fixed amount:&nbsp;&nbsp;</span>
            If a particular amount has to be used only for a particular Service
            Type, this should be selected. Example, if Rs. 10,000 sublimit is
            for gym and has to be used for gym only, select Fixed amount for Gym
            memberships.
          </li>
          <li>
            <span style={{ fontWeight: 600 }}>
              Per transaction limit:&nbsp;&nbsp;
            </span>
            Check this box to set a maximum amount that can be claimed in a
            single claim request.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the per transaction limit as either a Percentage (%) or an Amount
              (Rs.) for the Service type.
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: 600 }}>
              Co-Pay by employee:&nbsp;&nbsp;
            </span>
            Specify a portion of the amount that the employee is responsible for
            and cannot be claimed.
          </li>
          <ul style={{ marginBottom: "10px", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "4px" }}>
              <span style={{ fontWeight: 600 }}>Value:&nbsp;&nbsp;</span> Define
              the co-pay amount as either a Percentage (%) or an Amount (Rs.)
              for the Service type.
            </li>
          </ul>
          <li>
            <span style={{ fontWeight: 600 }}>Instructions:&nbsp;&nbsp;</span>
            Click this to add specific instructions for filing a claim under
            this category, such as required documents or submission procedures.
          </li>
          <li>
            <span style={{ fontWeight: 600 }}>+Add new:&nbsp;&nbsp;</span>
            Click to add a new claim type.
          </li>
        </ul>
      </div>
    );
  }

  if (num === 6) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows you to set additional rules to be considered while
          user is filing claims.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Apply invoice date rule:&nbsp;&nbsp;
            </span>
            By default user can file claims with invoice date between plan start
            date and end date. One standard customization which has to be
            applied for all the plans is how old invoices are acceptable in
            claims. Usually we accept up to 30 days old invoices for claims as
            long as the date is between plan start date and end date. To set
            this rule.
          </li>
        </ul>
        <div style={{ marginBottom: "10px" }}>
          (a) "Check" the "Apply invoice date rule" and
        </div>
        <div style={{ marginBottom: "10px" }}>
          (b) Mention the number of days in the space provided
        </div>
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Prior to the plan start date:&nbsp;&nbsp;
            </span>
            If the requirement is to even allow invoices prior to the plan start
            date, in that case "check" the "Prior to the plan start date".
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>Declaration:&nbsp;&nbsp;</span>
            This box is provided to get additional declaration from the user
            prior to claim submission. Standard statement to be mentioned is "I
            hereby declare that all invoices/ documents submitted by me are
            correct and I have not submitted the same claim anywhere else.".
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Document type (Label/Text):&nbsp;&nbsp;
            </span>
            If there is additional requirement of document type such as hard
            copy / soft copy and you want to add additional declaration, this
            text to be used.
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>+Add new:&nbsp;&nbsp;</span>
            Click to add a new document type or custom label and define its
            required declaration in the text.
          </li>
        </ul>
      </div>
    );
  }
  if (num === 7) {
    return (
      <div style={{ margin: 0, padding: 0, color: "#27284E" }}>
        <div style={{ marginBottom: "10px" }}>
          This section allows to define specific plan rules at the individual
          Service categories. These rules apply to the selected service
          category.
        </div>

        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Service category:&nbsp;&nbsp;
            </span>
            Select the specific category of service (e.g., Prescribed medicines,
            Consultation, etc.) for which you want to set an additional rule.
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Prescription required:&nbsp;&nbsp;
            </span>
            Check this box to enforce that a valid prescription is required for
            any claim or transaction related to the selected service category.
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>
              Prescribed medicines category allowed:&nbsp;&nbsp;
            </span>
            If 'Prescribed medicines' is the chosen service category, use this
            dropdown to restrict eligibility to a specific subset or type of
            medicine (e.g., only Ayurvedic medicines, only antibiotics, etc.).
          </li>
          <li style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: 600 }}>+Add new:&nbsp;&nbsp;</span>
            Click to add a new service category to define additional rules.
          </li>
        </ul>
      </div>
    );
  }

  return null; // return nothing for undefined input
};

export default getInfoText;
